export default __webpack_public_path__ + "0ad5320a5affd1c8a211dbe361a08511.svg";